import React from "react";
import axios from "axios";
import parseHtml from "html-react-parser";
import Header from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import Loader from "./shares/Loader.jsx";
import { encrypt, decrypt_res } from "./shares/GlobalFunction.jsx";
import { API_URL, SECRET_SESSION } from "../constants";

const baseURL = API_URL + "/login/info";

function InfoLogin() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [effectsCompleted, setEffectsCompleted] = React.useState(0);

  const [post, setPost] = React.useState(null);
  const navigate = useNavigate();
  React.useEffect(() => {
    axios.post(baseURL).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
      setEffectsCompleted((prev) => prev + 1);

      if (response.data.res.browser === 0) {
        const userAgent = navigator.userAgent;
        const browserIdentity = process.env.REACT_APP_BROWSER_IDENTITY;
        // alert(userAgent);
        if (!userAgent.includes(browserIdentity)) {
          navigate("/blocked");
          return false;
        }
      }
    });
  }, []);

  React.useEffect(() => {
    if (effectsCompleted >= 1) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);

  const toLogin = () => {
    navigate("/login");
  };

  const toSignUp = () => {
    navigate("/signup");
  };

  if (isLoading && !post) {
    return <Loader />;
  }

  return (
    <div className="App">
      <div className="App-header">
        <Header app_name={post && post.alamat} />
        <div
          className="login-container w-full sm:w-4/5 Bg-tutwuri contentLogin z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-5 "
          style={{
            minHeight: "200px",
            marginTop: "100px",
            marginBottom: "100px",
          }}
        >
          {parseHtml(post.informasi)}
          <div className="text-center">
            <button
              onClick={toLogin}
              type="button"
              className="bg-blue-500 hover:bg-blue-800 text-white py-2 px-4 rounded-xl"
            >
              Lanjutkan {post.camera ? " & Aktifkan Kamera " : ""}
            </button>
            {post.register_akun === 1 ? (
              <button
                onClick={toSignUp}
                type="button"
                className="bg-green-500 hover:bg-green-800 text-white py-2 px-4 rounded-xl ml-1"
              >
                Buat Akun Simulasi
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoLogin;
